/* eslint-disable jsx-a11y/media-has-caption */
import { useEffect, useRef } from 'react';
import Hls from 'hls.js';

import useInView from 'Hooks/useInView';

import PlayIcon from 'Icons/playicon.svg?react';

interface VideoPlayerProps {
    altDescription: string;
    url: string;
}

const VideoPlayerGalleryThumbnail = ({
    altDescription,
    url,
}: VideoPlayerProps) => {
    const hlsInstance = useRef<Hls>(null);
    const videoRef = useRef<HTMLVideoElement>(null);
    const { inView: isInView } = useInView(videoRef, true);

    useEffect(() => {
        if (!url) return;

        if (Hls.isSupported()) {
            const hls = new Hls({
                maxMaxBufferLength: 60,
            });
            hlsInstance.current = hls;
            hlsInstance.current.loadSource(url);

            hlsInstance.current.currentLevel = -1;
            hlsInstance.current.on(Hls.Events.MANIFEST_LOADED, () => {
                const { levels } = hlsInstance.current;
                if (levels && levels.length > 0) {
                    const lastLevel = levels.length - 1;
                    hlsInstance.current.currentLevel = lastLevel;
                }
            });
        } else if (
            videoRef.current.canPlayType('application/vnd.apple.mpegurl')
        ) {
            videoRef.current.src = url;
        }

        return () => {
            if (hlsInstance.current) {
                if (Hls.isSupported()) {
                    hlsInstance.current.destroy();
                    hlsInstance.current = null;
                }
            }
        };
    }, [url]);

    useEffect(() => {
        if (Hls.isSupported()) {
            if (videoRef.current && hlsInstance.current && isInView) {
                hlsInstance.current.attachMedia(videoRef.current);
            }
        }
    }, [isInView]);

    return (
        <div className="relative h-full w-full">
            <video
                className="absolute left-0 top-0  h-full w-full object-cover"
                ref={videoRef}
                title={altDescription}
                preload="metadata"
            />
            <span className="absolute left-1/2 top-1/2  grid h-14 w-14 -translate-x-1/2 -translate-y-1/2 cursor-pointer place-items-center rounded-full border border-transparent bg-black shadow-[0px_0px_20px_1px_#00000025] transition-colors duration-layout hover:bg-persianPink group-focus-visible:border-black group-focus-visible:shadow-[inset_0_0_0_2px_rgb(27_127_204_/_.9)]">
                <PlayIcon className="relative left-0.5 h-6 w-6 fill-white text-white" />
            </span>
        </div>
    );
};

export default VideoPlayerGalleryThumbnail;
